<template>
  <div class="root d-inline-block">
    <div>
      <button  class="btn btn-secondary" >
        <i class="icon-eye-outline"></i>
      </button>
    </div>
  </div>
</template>

<script>
  import { mapState, mapMutations, mapActions } from "vuex";
  import EventBus from "../bus.js";

  export default {
    name: "work-status",
    components: {},
    data() {
      return {
        worksDone: null
      }
    },
    mounted() {
    },
    methods: {

      /*updateMaterialTable(data) {
        this.$store.commit("ADD_ROW_TO_VS_TABLE_FEED", {
          id: Math.random() * 100,
          material: data.material,
          percentage: data.percentage
        });
        // this.voucherModel.voucherProductDto.push({
        //   productId: data.productId,
        //   unitVal: data.number || data.unitVal,
        //   price: data.price,
        //   productName: data.productName
        // });
      },*/
      refreshMaterialTable() {
        this.show = false;
        setTimeout(() => {
          this.show = true;
        }, 50);
      }
    },
    computed: {
      ...mapState(["selectedRows", "currentService", "vsTableFeed"])
    },
    watch: {
      vsTableFeed(val) {
        //this.refreshMaterialTable();
      },
    }
  };
</script>

<style scoped>
  hr {
    background-color: rgba(255, 255, 255, 0.4);
  }

  .input-group > div:not(.custom) {
    display: flex;
    flex: 1;
  }
</style>
